module.exports = new __parcel__URL__("taxExemptionIcon.1a723539.png").toString();